/**
 * Modern Skeleton Component
 *
 * Premium loading skeleton with shimmer effect.
 * Used for modern, professional loading states.
 */

import {cn} from "@/shared/utils/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
 variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
 width?: string | number;
 height?: string | number;
 animate?: boolean;
}

export function Skeleton({
 className,
 variant = 'rectangular',
 width,
 height,
 animate = true,
 style,
 ...props
}: SkeletonProps): React.ReactElement {
 const variantStyles = {
 text: 'h-4 rounded',
 circular: 'rounded-full',
 rectangular: 'rounded-md',
 rounded: 'rounded-lg',
 };

 return (
 <div
 className={cn(
 'skeleton-advanced',
 variantStyles[variant],
 'relative overflow-hidden',
 animate && 'animate-pulse',
 className
 )}
 style={{
 width: width || (variant === 'text' ? '100%' : undefined),
 height: height || (variant === 'text' ? undefined : '1rem'),
 ...style,
 }}
 {...props}
 >
 {animate && (
 <div className="absolute inset-0 bg-gradient-to-r from-transparent via-card/20 to-transparent animate-shimmer"/>
 )}
 </div>
 );
}

/**
 * Skeleton Group - For complex loading states
 */
export function SkeletonGroup({
 children,
 className,
 ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
 return (
 <div className={cn('space-y-3', className)} {...props}>
 {children}
 </div>
 );
}
